import { render, staticRenderFns } from "./DataLoader.vue?vue&type=template&id=bba44ee4&scoped=true&"
import script from "./DataLoader.vue?vue&type=script&lang=js&"
export * from "./DataLoader.vue?vue&type=script&lang=js&"
import style0 from "./DataLoader.vue?vue&type=style&index=0&id=bba44ee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba44ee4",
  null
  
)

export default component.exports